/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ClientDto,
  CountClientsParams,
  GetClientsParams,
  UserFederationResultDto,
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType, BodyType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN**<br /><br />
 */
export const getClients = (
  userId: string,
  params?: GetClientsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ClientDto[]>(
    { url: `/api/${userId}/clients`, method: 'GET', params, signal },
    options
  );
};

export const getGetClientsQueryKey = (
  userId: string,
  params?: GetClientsParams
) => {
  return [`/api/${userId}/clients`, ...(params ? [params] : [])] as const;
};

export const getGetClientsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClients>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params?: GetClientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClientsQueryKey(userId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClients>>> = ({
    signal,
  }) => getClients(userId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClients>>
>;
export type GetClientsQueryError = ErrorType<unknown>;

export function useGetClients<
  TData = Awaited<ReturnType<typeof getClients>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params: undefined | GetClientsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClients>>,
          TError,
          Awaited<ReturnType<typeof getClients>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClients<
  TData = Awaited<ReturnType<typeof getClients>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params?: GetClientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClients>>,
          TError,
          Awaited<ReturnType<typeof getClients>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClients<
  TData = Awaited<ReturnType<typeof getClients>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params?: GetClientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetClients<
  TData = Awaited<ReturnType<typeof getClients>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params?: GetClientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClientsQueryOptions(userId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN**<br /><br />
 */
export const updateClient = (
  userId: string,
  clientDto: BodyType<ClientDto>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ClientDto>(
    {
      url: `/api/${userId}/clients`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: clientDto,
      signal,
    },
    options
  );
};

export const getUpdateClientMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClient>>,
    TError,
    { userId: string; data: BodyType<ClientDto> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateClient>>,
  TError,
  { userId: string; data: BodyType<ClientDto> },
  TContext
> => {
  const mutationKey = ['updateClient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateClient>>,
    { userId: string; data: BodyType<ClientDto> }
  > = (props) => {
    const { userId, data } = props ?? {};

    return updateClient(userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateClientMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateClient>>
>;
export type UpdateClientMutationBody = BodyType<ClientDto>;
export type UpdateClientMutationError = ErrorType<unknown>;

export const useUpdateClient = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateClient>>,
      TError,
      { userId: string; data: BodyType<ClientDto> },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateClient>>,
  TError,
  { userId: string; data: BodyType<ClientDto> },
  TContext
> => {
  return useMutation(getUpdateClientMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN**<br /><br />
 */
export const createClient = (
  userId: string,
  clientDto: BodyType<ClientDto>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ClientDto>(
    {
      url: `/api/${userId}/clients`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: clientDto,
      signal,
    },
    options
  );
};

export const getCreateClientMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClient>>,
    TError,
    { userId: string; data: BodyType<ClientDto> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createClient>>,
  TError,
  { userId: string; data: BodyType<ClientDto> },
  TContext
> => {
  const mutationKey = ['createClient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createClient>>,
    { userId: string; data: BodyType<ClientDto> }
  > = (props) => {
    const { userId, data } = props ?? {};

    return createClient(userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateClientMutationResult = NonNullable<
  Awaited<ReturnType<typeof createClient>>
>;
export type CreateClientMutationBody = BodyType<ClientDto>;
export type CreateClientMutationError = ErrorType<unknown>;

export const useCreateClient = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createClient>>,
      TError,
      { userId: string; data: BodyType<ClientDto> },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createClient>>,
  TError,
  { userId: string; data: BodyType<ClientDto> },
  TContext
> => {
  return useMutation(getCreateClientMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN**<br /><br />
 */
export const migrateUsersToOktaCredentials = (
  userId: string,
  clientId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<UserFederationResultDto>(
    {
      url: `/api/${userId}/clients/${clientId}/migrate-users-to-okta`,
      method: 'POST',
      signal,
    },
    options
  );
};

export const getMigrateUsersToOktaCredentialsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof migrateUsersToOktaCredentials>>,
    TError,
    { userId: string; clientId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof migrateUsersToOktaCredentials>>,
  TError,
  { userId: string; clientId: number },
  TContext
> => {
  const mutationKey = ['migrateUsersToOktaCredentials'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof migrateUsersToOktaCredentials>>,
    { userId: string; clientId: number }
  > = (props) => {
    const { userId, clientId } = props ?? {};

    return migrateUsersToOktaCredentials(userId, clientId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MigrateUsersToOktaCredentialsMutationResult = NonNullable<
  Awaited<ReturnType<typeof migrateUsersToOktaCredentials>>
>;

export type MigrateUsersToOktaCredentialsMutationError = ErrorType<unknown>;

export const useMigrateUsersToOktaCredentials = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof migrateUsersToOktaCredentials>>,
      TError,
      { userId: string; clientId: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof migrateUsersToOktaCredentials>>,
  TError,
  { userId: string; clientId: number },
  TContext
> => {
  return useMutation(
    getMigrateUsersToOktaCredentialsMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **ROLE_SUPER_ADMIN**<br /><br />
 */
export const federateUsers = (
  userId: string,
  clientId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<UserFederationResultDto>(
    {
      url: `/api/${userId}/clients/${clientId}/federate-users`,
      method: 'POST',
      signal,
    },
    options
  );
};

export const getFederateUsersMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof federateUsers>>,
    TError,
    { userId: string; clientId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof federateUsers>>,
  TError,
  { userId: string; clientId: number },
  TContext
> => {
  const mutationKey = ['federateUsers'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof federateUsers>>,
    { userId: string; clientId: number }
  > = (props) => {
    const { userId, clientId } = props ?? {};

    return federateUsers(userId, clientId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type FederateUsersMutationResult = NonNullable<
  Awaited<ReturnType<typeof federateUsers>>
>;

export type FederateUsersMutationError = ErrorType<unknown>;

export const useFederateUsers = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof federateUsers>>,
      TError,
      { userId: string; clientId: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof federateUsers>>,
  TError,
  { userId: string; clientId: number },
  TContext
> => {
  return useMutation(getFederateUsersMutationOptions(options), queryClient);
};
/**
 * Authorities: **Any authenticated role**
 */
export const getClientById = (
  userId: string,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ClientDto>(
    { url: `/api/${userId}/clients/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetClientByIdQueryKey = (userId: string, id: number) => {
  return [`/api/${userId}/clients/${id}`] as const;
};

export const getGetClientByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClientByIdQueryKey(userId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientById>>> = ({
    signal,
  }) => getClientById(userId, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientById>>
>;
export type GetClientByIdQueryError = ErrorType<unknown>;

export function useGetClientById<
  TData = Awaited<ReturnType<typeof getClientById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientById>>,
          TError,
          Awaited<ReturnType<typeof getClientById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientById<
  TData = Awaited<ReturnType<typeof getClientById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientById>>,
          TError,
          Awaited<ReturnType<typeof getClientById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientById<
  TData = Awaited<ReturnType<typeof getClientById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetClientById<
  TData = Awaited<ReturnType<typeof getClientById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClientByIdQueryOptions(userId, id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN**<br /><br />
 */
export const countClients = (
  userId: string,
  params?: CountClientsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<number>(
    { url: `/api/${userId}/clients/count`, method: 'GET', params, signal },
    options
  );
};

export const getCountClientsQueryKey = (
  userId: string,
  params?: CountClientsParams
) => {
  return [`/api/${userId}/clients/count`, ...(params ? [params] : [])] as const;
};

export const getCountClientsQueryOptions = <
  TData = Awaited<ReturnType<typeof countClients>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params?: CountClientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countClients>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCountClientsQueryKey(userId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof countClients>>> = ({
    signal,
  }) => countClients(userId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof countClients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CountClientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof countClients>>
>;
export type CountClientsQueryError = ErrorType<unknown>;

export function useCountClients<
  TData = Awaited<ReturnType<typeof countClients>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params: undefined | CountClientsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countClients>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countClients>>,
          TError,
          Awaited<ReturnType<typeof countClients>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCountClients<
  TData = Awaited<ReturnType<typeof countClients>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params?: CountClientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countClients>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countClients>>,
          TError,
          Awaited<ReturnType<typeof countClients>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCountClients<
  TData = Awaited<ReturnType<typeof countClients>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params?: CountClientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countClients>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useCountClients<
  TData = Awaited<ReturnType<typeof countClients>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params?: CountClientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countClients>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCountClientsQueryOptions(userId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN**<br /><br />
 */
export const deleteClient = (
  userId: string,
  clientId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    { url: `/api/${userId}/clients/${clientId}`, method: 'DELETE', signal },
    options
  );
};

export const getDeleteClientMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClient>>,
    TError,
    { userId: string; clientId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteClient>>,
  TError,
  { userId: string; clientId: number },
  TContext
> => {
  const mutationKey = ['deleteClient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteClient>>,
    { userId: string; clientId: number }
  > = (props) => {
    const { userId, clientId } = props ?? {};

    return deleteClient(userId, clientId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteClientMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteClient>>
>;

export type DeleteClientMutationError = ErrorType<unknown>;

export const useDeleteClient = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteClient>>,
      TError,
      { userId: string; clientId: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteClient>>,
  TError,
  { userId: string; clientId: number },
  TContext
> => {
  return useMutation(getDeleteClientMutationOptions(options), queryClient);
};
